import { createEnv } from '@t3-oss/env-nextjs'
import { getEnvironment, isDevelopment, isPreview, isProduction, isTest } from './environment'
import { developmentEnv } from './variables/development'
import { previewEnv } from './variables/preview'
import { productionEnv } from './variables/production'
import { testEnv } from './variables/test'

function getCurrentEnv() {
  const currentEnv = getEnvironment()

  switch (currentEnv) {
    case 'development': {
      return createEnv(developmentEnv)
    }
    case 'test': {
      return createEnv(testEnv)
    }
    case 'preview': {
      return createEnv(previewEnv)
    }
    case 'production': {
      return createEnv(productionEnv)
    }
  }
}

export const env = {
  ...getCurrentEnv(),

  environment: getEnvironment(),
  isDevelopment,
  isPreview,
  isProduction,
  isTest
} as const
